import React, { useState, useEffect, useRef } from "react";
import mes from "../../assets/images/Chat/mes.svg";
import { RiCloseLargeLine } from "react-icons/ri";
import fone from "../../assets/images/Chat/fone.svg";
import maill from "../../assets/images/Chat/maill.svg";
import mess from "../../assets/images/Chat/mess.svg";
import zalll from "../../assets/images/Chat/zalll.svg";

export default function ButtonChat() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const handleMouseEnter = () => {
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative">
      <button
        ref={buttonRef}
        className={`w-16 h-16 border-4 p-2 transition-all duration-300 ease-in-out ${
          isOpen ? "bg-[#052f9c] scale-110" : "bg-white"
        } border-[#052f9c] rounded-full shadow-lg focus:outline-none fixed z-50 bottom-6 right-6 lg:bottom-4 lg:right-4 flex items-center justify-center text-white`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {isOpen ? (
          <RiCloseLargeLine className="w-6 h-6" />
        ) : (
          <div className="flex items-center justify-center animate-ping">
            <img
              src={mess}
              alt="Messenger icon"
              className="w-7 h-7 transition-transform duration-300 ease-in-out"
            />
          </div>
        )}
      </button>

      {isOpen && (
        <div
          ref={menuRef}
          className="fixed bottom-[98px] transition-all z-40 duration-300 ease-in-out right-6 lg:right-4 border border-white bg-white p-2 rounded-lg shadow-lg w-64 h-56 text-black"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className="absolute bottom-[-17px] right-3 w-0 h-0 border-l-[20px] border-r-[20px] border-t-[20px] border-white shadow-2xl border-l-transparent border-r-transparent"></div>

          <div className="flex flex-col gap-1 items-center w-full">
            <div className="flex items-center w-full gap-1 hover:bg-slate-100 rounded cursor-pointer transition-transform duration-300 ease-in-out">
              <img
                src={mes}
                alt="MS"
                className="h-12 w-12 transform transition-transform duration-300 ease-in-out hover:scale-110"
              />
              <a
                href="https://m.me/HeSinhThaiGiaoDucBlueRise"
                target="_blank"
                rel="noopener noreferrer"
                className="block whitespace-nowrap"
              >
                Nhắn tin qua Messenger
              </a>
            </div>
            <div className="flex items-center w-full gap-1 hover:bg-slate-100 rounded cursor-pointer transition-transform duration-300 ease-in-out">
              <img
                src={zalll}
                alt="zalll"
                className="h-12 w-12 transform transition-transform duration-300 ease-in-out hover:scale-110"
              />
              <a
                href="https://zalo.me/0981317225"
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                Nhắn tin qua Zalo
              </a>
            </div>
            <div className="flex items-center w-full gap-1 hover:bg-slate-100 rounded cursor-pointer transition-transform duration-300 ease-in-out">
              <img
                src={fone}
                alt="fone"
                className="w-12 h-12 transform transition-transform duration-300 ease-in-out hover:scale-110"
              />
              <a target="_blank" rel="noopener noreferrer" className="block">
                0981 317 225
              </a>
            </div>
            <div className="flex items-center w-full gap-1 hover:bg-slate-100 rounded cursor-pointer transition-transform duration-300 ease-in-out">
              <img
                src={maill}
                alt="maill"
                className="h-12 w-12 transform transition-transform duration-300 ease-in-out hover:scale-110"
              />
              <a target="_blank" rel="noopener noreferrer" className="block">
                cskh@bluerise.com.vn
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
